import { render, staticRenderFns } from "./DropdownLink.vue?vue&type=template&id=4630c1c5&scoped=true&"
import script from "./DropdownLink.vue?vue&type=script&lang=js&"
export * from "./DropdownLink.vue?vue&type=script&lang=js&"
import style0 from "./DropdownLink.vue?vue&type=style&index=0&id=4630c1c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4630c1c5",
  null
  
)

export default component.exports